import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { UserRole } from '../models/auth.interface';

export const guestGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Same test as authGuard, or a signed-in non-SUPER_ADMIN would bounce between the two forever.
  if (authService.currentUser()?.role !== UserRole.SUPER_ADMIN) {
    return true;
  }

  return router.parseUrl('/dashboard');
};
